module.exports = __webpack_public_path__ + "media/images/service/zr-db42d4f00ec7f4341856fc4d2b0917a5.png";